<template>
  <v-container>
    <section class="pb-12" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
      <h2 class="text-center mb-2 ">
        {{ $t("Add_offer") }} 
      </h2>
      <label class="form-label">
        {{ $t("Area") }} :
      </label>
      <Multiselect
        :options="optionsarea"
        :searchable="true"
        :placeholder="$t('Area')"
        label="name"
        class="selectnew"
        v-model="formData.area_id"
        @change="areachange"

      />
      <label class="form-label">
        {{ $t("City") }} :
      </label>
      <multiselect
        :options="optionscity"
        :searchable="true"
        :selected="null"
        :placeholder="$t('City')"
        label="name"
        class="selectnew"
        v-model="formData.city_id"
        @change="citychange"
      ></multiselect>
      <label class="form-label">
        {{ $t("neighborhood") }} :
      </label>
      <multiselect
        :options="optionsneighborhood"
        :searchable="true"
        :placeholder="$t('neighborhood')"
        label="name"
        class="selectnew"
        v-model="formData.neighborhood_id"
        @change="neighborhoodchange"
      ></multiselect>
      <label class="form-label">
        {{ $t("estate_type") }} :
      </label>
      <Multiselect
        :options="optionsestate"
        :searchable="true"
        :placeholder="$t('estate_type')"
        label="name"
        class="selectnew"
        v-model="formData.estate_type_id"
        @change="estate($event)"
      />
      <label class="font-weight-bold">
        {{ $t("ads_type") }}
      </label>
      <Multiselect
        :options="optionsadtype"
        :searchable="true"
        :placeholder="$t('ads_type')"
        label="name"
        class="selectnew"
        v-model="formData.ad_type_id"
      />
      <label class="form-label">
        {{ $t("usage_type") }} :
      </label>
      <Multiselect
        :options="optionsusagetype"
        :searchable="true"
        :placeholder="$t('usage_type')"
        label="name"
        class="selectnew"
        v-model="formData.usage_type_id"
        @change="usage($event)"
      />
      <label class="form-label">
        {{ $t("description") }} :
      </label>
      <v-text-field
        variant="solo"
        class="selectnew"
        v-model="formData.description"
      ></v-text-field>
      <!-- <label class="font-weight-bold">
        {{ $t("address") }}
      </label>
      <v-text-field
        variant="solo"
        class="selectnew"
        v-model="formData.address"
      ></v-text-field> -->
      <label class="form-label">
        {{ $t("Location_Details") }} :
      </label>
      <v-text-field
        variant="solo"
        class="selectnew"
        v-model="formData.location"
      ></v-text-field>
      <label class="form-label">
        {{ $t("map_url") }} :
      </label>
      <v-text-field
        variant="solo"
        class="selectnew"
        v-model="formData.map_url"
      ></v-text-field>
      <label class="form-label">
        {{ $t("lat") }} :
      </label>
      <v-text-field
      type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.lat"
      ></v-text-field>
      <label class="form-label">
        {{ $t("lang") }} :
      </label>
      <v-text-field
      type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.lng"
      ></v-text-field>
      <label class="form-label">
        {{ $t("price") }} :
      </label>
      <v-text-field
        type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.price"
      ></v-text-field>
    

      <label class="form-label">
        {{ $t("Aarea") }} :
      </label>
      <v-text-field
        type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.area"
      ></v-text-field>
   
      <!-- <label class="font-weight-bold">
        {{ $t("mortgage") }}
      </label>
      <v-text-field
        type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.mortgage"
      ></v-text-field> -->
    
      <label class="form-label">
        {{ $t("advertiser_orientation") }} :
      </label>
      <Multiselect
        :options="optionsadvertiserorientation"
        :searchable="true"
        :placeholder="$t('advertiser_orientation')"
        label="name"
        class="selectnew"
        v-model="formData.advertiser_orientation_id"
      />
      <label class="form-label">
        {{ $t("advertiser_type") }} :
      </label>
      <Multiselect
        :options="optionadvertisertype"
        :searchable="true"
        :placeholder="$t('advertiser_type')"
        label="name"
        class="selectnew"
        v-model="formData.advertiser_type"
        @change="advertiserTypeChange"
      />
      <template v-if="formData.advertiser_type === 'delegate'">
        <label class="form-label">
          {{ $t("license_number") }} :
        </label>
        <v-text-field
          type="number"
          variant="solo"
          class="selectnew"
          v-model="formData.license_number"
        ></v-text-field>
        <label class="form-label">
          {{ $t("delegation_number") }} :
        </label>
        <v-text-field
          type="number"
          variant="solo"
          class="selectnew"
          v-model="formData.delegation_number"
        ></v-text-field>
      </template>
      <!-- <label class="font-weight-bold">
        {{ $t("advertiser_registration_number") }}
      </label>
      <v-text-field
        type="number"
        variant="solo"
        class="selectnew"
        v-model="formData.advertiser_registration_number"
      ></v-text-field> -->
      <div class="checkboxes-container">
        <v-checkbox
          :label="$t('special')"
          class="check"
          @change="checkspcial"
        ></v-checkbox>
        <v-checkbox 
          :label="$t('Story')" 
          class="check" 
          @change="checked" 
          v-if="story"
        ></v-checkbox>
      </div>
      <label class="form-label">
        {{ $t("media") }} :
      </label>
      <div class="file-upload-container">
        <div class="file-upload-area" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
          <input
            ref="fileInput"
            type="file"
            multiple
            accept="image/*,video/*"
            @change="handleFileChange"
            style="display: none"
          />
          <div class="upload-content">
            <v-icon size="48" color="primary">mdi-cloud-upload</v-icon>
            <p class="upload-text">{{ $t("drag_drop_files") }}</p>
            <p class="upload-subtext">{{ $t("or_click_to_select") }}</p>
            <p class="upload-hint">{{ $t("supports_images_videos") }}</p>
          </div>
        </div>
        <div v-if="formData.attachment && formData.attachment.length > 0" class="files-preview">
          <div v-for="(file, index) in formData.attachment" :key="index" class="file-preview-item">
            <div class="file-preview-content">
              <img v-if="file.type && file.type.startsWith('image/')" :src="getFilePreview(file)" alt="Preview" class="preview-image" />
              <video v-else-if="file.type && file.type.startsWith('video/')" :src="getFilePreview(file)" class="preview-video" controls></video>
              <v-icon v-else size="40" color="grey">mdi-file</v-icon>
              <div class="file-info">
                <p class="file-name">{{ file.name || `File ${index + 1}` }}</p>
                <p class="file-size">{{ formatFileSize(file.size) }}</p>
              </div>
            </div>
            <v-btn
              icon
              size="small"
              color="error"
              @click="removeFile(index)"
              class="remove-btn"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <v-row class="mt-2">
        <v-col cols="12" md="3" v-for="item in optionproperties" :key="item.id">
          <label class="form-label">
            {{ item.name }}:
          </label>
          <input
            type="range"
            class="d-block form-control selectnew"
            :min="item.min_value"
            :max="item.max_value"
            style="border-style: solid"
            v-if="item.type == 'slider'"
            v-model="optionsAdd[item.id]"
          />
          <Multiselect
            v-else-if="item.type == 'multi'"
            :options="item.values_ar"
            :searchable="true"
            class="selectnew"
            v-model="optionsAdd[item.id]"
          />
          <v-checkbox
            v-else-if="item.type == 'switch'"
            class="check"
            v-model="optionsAdd[item.id]"
          ></v-checkbox>

          <v-text-field
            v-else
            :type="item.type"
            variant="solo"
            class="selectnew"
            :min="item.min_value"
            :max="item.max_value"
            v-model="optionsAdd[item.id]"
          ></v-text-field>

          <!-- @change="prepareAndAddData(item.id, $event, item.name)" -->
        </v-col>
      </v-row>
      <div class="d-flex align-center">
        <v-checkbox class="check d-flex flex-0-0" @change="check"></v-checkbox>
        <v-tooltip location="top" :text="$t('click_to_view_conditions')">
          <template v-slot:activator="{ props }">
            <button 
              v-bind="props"
              class="conditions-btn"
              @click="dialog = true"
            >
              <v-icon size="20" class="conditions-icon">mdi-file-document-outline</v-icon>
              <span>{{ $t("Conditions_advertisement") }}</span>
            </button>
          </template>
        </v-tooltip>
      </div>
      <div class="text-red">{{ errorMessage ? errorMessage : "" }}</div>

      <div class="text-center">
        <button 
          class="add-ad-btn" 
          :class="{ 'loading': isLoading }"
          :disabled="isLoading"
          @click="addnewad"
        >
          <span v-if="!isLoading" class="btn-content">
            <v-icon size="20" class="btn-icon">mdi-plus-circle</v-icon>
            <span class="btn-text">{{ $t("Add_new_ad") }}</span>
          </span>
          <span v-else class="btn-loading">
            <v-progress-circular
              indeterminate
              color="white"
              size="20"
              width="2"
              class="loading-spinner"
            ></v-progress-circular>
            <span class="btn-text">{{ $t("Adding") }}</span>
          </span>
        </button>
      </div>
      <v-dialog v-model="dialog" width="700">
        <v-card class="text-center py-5">
          <h3
            class="w-max-content mx-auto rounded pa-1 text-h5 font-weight-bold bg-yellow-darken-1"
          >
            {{ $t("Conditions_advertisement") }}
          </h3>
          <p class="pa-5 text-h6">
            هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا
            النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد
            من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.إذا
            كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد
            الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية، مولد النص
            العربى مفيد لمصممي المواقع على وجه الخصوص، حيث يحتاج العميل فى كثير
            من الأحيان أن يطلع على صورة حقيقية لتصميم الموقع.ومن هنا وجب على
            المصمم أن يضع نصوصا مؤقتة على التصميم ليظهر للعميل الشكل كاملاً،دور
            مولد النص العربى أن يوفر على المصمم عناء البحث عن نص بديل لا علاقة
            له بالموضوع الذى يتحدث عنه التصميم فيظهر بشكل لا يليق.هذا النص يمكن
            أن يتم تركيبه على أي تصميم دون مشكلة فلن يبدو وكأنه نص منسوخ، غير
            منظم، غير منسق، أو حتى غير مفهوم. لأنه مازال نصاً بديلاً ومؤقتاً.
          </p>
        </v-card>
      </v-dialog>
    </section>
    <v-snackbar
      v-model="showSnackbar"
      color="yellow-darken-2
"
    >
      {{ $t("Added_successfully") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" v-bind="attrs" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import crudDataService from "@/Services/crudDataService";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      showSnackbar: false,
      errorMessage: "",
      eventchange: "",
      dialog: false,
      isLoading: false,
      optionscity: [],
      optionsarea: [],
      optionsneighborhood: [],
      optionsestate: [],
      // optionsadtype: [],
      optionsusagetype: [],
      optionsmaintype: [],
      optionsadvertiserorientation: [],
      optionadvertisertype: [],
      nei_id: "",
      formData: {
        city_id: "",
        neighborhood_id: "",
        area_id: "",
        estate_type_id: "",
        ad_type_id: "",
        usage_type_id: "",
        main_type: "sell",
        description: "",
        address: "",
        location: "",
        map_url: "",
        lng: "",
        lat: "",
        price: "",
        area: "",
        estate_notes: 0,
        advertiser_orientation_id: "",
        advertiser_type: "",
        license_number: "",
        delegation_number: "",
        advertiser_registration_number: "",
        attachment: [],
        is_story: 0,
        special: 0,
        options: [],
        usage_id: "",
        estate_id: "",
      },
      optionsAdd:[],
      optionproperties: [],
      story:true,
      areaname:'',
      cityname:'',
      neighborhoodname:""

    };
  },
  methods: {
    async getstories() {
      let response = await crudDataService.getAll("stories");
      if (response.data.data.ads[0]) {
        this.story = response.data.data.ads[0].is_story==1?false:true;
      console.log(this.story);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
      // Reset input to allow selecting the same file again
      event.target.value = '';
    },
    handleDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    addFiles(files) {
      const validFiles = files.filter(file => {
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        return isImage || isVideo;
      });
      
      if (validFiles.length > 0) {
        if (!this.formData.attachment) {
          this.formData.attachment = [];
        }
        this.formData.attachment.push(...validFiles);
      }
    },
    removeFile(index) {
      this.formData.attachment.splice(index, 1);
    },
    getFilePreview(file) {
      if (file instanceof File) {
        return URL.createObjectURL(file);
      }
      return '';
    },
    formatFileSize(bytes) {
      if (!bytes) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    checked(e) {
      if (e.target.checked) {
        this.formData.is_story = 1;
      } else {
        this.formData.is_story = 0;
      }
    },
    check(e) {
      if (e.target.checked) {
        this.formData.estate_notes = 1;
      } else {
        this.formData.estate_notes = 0;
      }
    },
    checkspcial(e) {
      if (e.target.checked) {
        this.formData.special = 1;
      } else {
        this.formData.special = 0;
      }
    },
  
    async Areas() {
      let response = await crudDataService.getAll(`areas`);
      this.optionsarea = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },
   
    areachange(e,name){
      this.areaid=e;
      this.areaname=name.ariaLabel
      this.City();
    },
    
    async City() {
      let response = await crudDataService.getAll(`cities?area_id=${this.areaid}`);
      this.optionscity = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },
    citychange(e,name) {
      this.nei_id = e;
      this.cityname=name.ariaLabel
      this.neighborhood_id();
    },
    neighborhoodchange(e,name) {
      this.neighborhoodname=name.ariaLabel
    },
    async neighborhood_id() {
      let response = await crudDataService.getAll(
        `neighborhoods?city_id=${this.nei_id}`
      );
      this.optionsneighborhood = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    
    
    },
    async estate_types() {
      let response = await crudDataService.getAll(`estate-types`);
      this.optionsestate = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },
    async ad_types() {
      let response = await crudDataService.getAll(`ad-types`);
      this.optionsadtype = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },
    async usage_types() {
      let response = await crudDataService.getAll(`usage-types`);
      this.optionsusagetype = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },

    async advertiser_orientation() {
      let response = await crudDataService.getAll(`advertiserOrientation`);
      this.optionsadvertiserorientation = response.data.data.map((state) => ({
        value: state.id,
        name: state.name,
      }));
    },
    async advertiser_type() {
      this.optionadvertisertype = [
        { value: "owner", name: this.$t("owner") },
        { value: "delegate", name: this.$t("delegate") },
      ];
    },
    advertiserTypeChange(value) {
      if (value === "owner") {
        this.formData.license_number = "";
        this.formData.delegation_number = "";
      }
    },
  
    estate(e) {
      this.estate_id = e;
      console.log(e);
    },
    usage(e) {
      this.usage_id = e;
      console.log(e);
      this.properties();
    },
    async properties() {
      let response = await crudDataService.getAll(
        `properties/${this.estate_id}/${this.usage_id}`
      );
      this.optionproperties = response.data.data;
    },
    prepareAndAddData() {
  this.formData.options = Object.entries(this.optionsAdd).map(([key, value]) => {
    return {
      property_id: key,
      values: [value], // Assuming each value is what you want to add
    };
  });
},
      
    async addnewad() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      this.errorMessage = "";
      
      try {
        this.prepareAndAddData();
        this.formData.address = this.areaname + ' ' + this.cityname + ' ' + this.neighborhoodname;

        console.log(this.formData.options);
        
        await crudDataService.create(`store-ad`, this.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        
        this.showSnackbar = true;
        setTimeout(() => {
          this.$router.push("/");
        }, 5000);
      } catch (error) {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        } else if (error.request) {
          this.errorMessage = "No response from the server";
        } else {
          this.errorMessage = error.message;
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.Areas();
    this.City();
    this.ad_types();
    this.estate_types();
    this.usage_types();
    this.advertiser_orientation();
    this.advertiser_type();
    this.getstories()
  },
};
</script>

<style lang="scss">
/* Form Labels Styles */
.form-label {
  display: block;
  font-weight: 600;
  font-size: 18px;
  color: #1f2937;
  margin-bottom: 8px;
  margin-top: 20px;
  letter-spacing: 0.3px;
  padding-right: 12px;
  transition: all 0.2s ease;
  line-height: 1.5;

 

  &:first-child {
    margin-top: 0;
  }

  // Support for RTL (Arabic)
  [dir="rtl"] & {
    padding-right: 0;
    padding-left: 12px;
  }

  // Support for LTR (English)
  [dir="ltr"] & {
    padding-left: 12px;
    padding-right: 0;

    &::before {
      left: 0;
      right: auto;
    }
  }
}

@media (max-width: 768px) {
  .form-label {
    font-size: 14px;
    margin-top: 18px;
    margin-bottom: 6px;
  }
}

.selectnew {
  &.multiselect {
    margin-top: 8px;
    margin-bottom: 10px;
    border-radius: 10px;
  }
  .multiselect-search {
    border-radius: 10px;
  }
}
.selectnew.v-input--density-default .v-field--variant-outlined,
.selectnew.v-input--density-default .v-field--single-line,
.selectnew.v-input--density-default .v-field--no-label {
  box-shadow: none !important;
  border: 1px solid #d1d5db !important;
  border-radius: 10px !important;
  margin-top: 6px;
  margin-bottom: 8px;
}
.check .v-input__details,
.selectnew .v-input__details {
  display: none !important;
}

/* Checkboxes Container */
.checkboxes-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  [dir="rtl"] & {
    justify-content: flex-start;
  }
  .v-checkbox .v-selection-control {
    justify-content: flex-end !important;
  }

  .check {
    margin: 0;
  }
}
.selectnew.v-text-field input.v-field__input {
  min-height: 20px;
  padding-top: 7px;
  padding-bottom: 7px;
}

/* File Upload Styles */
.file-upload-container {
  margin-top: 8px;
  margin-bottom: 16px;
}

.file-upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #3b82f6;
    background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.5s;
  }

  &:hover::before {
    left: 100%;
  }
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}

.upload-text {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.upload-subtext {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.upload-hint {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
  margin-top: 4px;
}

.files-preview {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.file-preview-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }
}

.file-preview-content {
  position: relative;
  width: 100%;
  padding-top: 100%; /* Square aspect ratio */
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image,
.preview-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-video {
  background: #000;
}

.file-info {
  padding: 12px;
  background: #ffffff;
}

.file-name {
  font-size: 12px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-size {
  font-size: 11px;
  color: #6b7280;
  margin: 0;
}

.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(239, 68, 68, 0.9) !important;
  backdrop-filter: blur(4px);
  z-index: 10;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);

  &:hover {
    background: rgba(220, 38, 38, 1) !important;
    transform: scale(1.1);
  }
}

@media (max-width: 768px) {
  .files-preview {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
  }

  .file-upload-area {
    padding: 30px 15px;
  }

  .upload-text {
    font-size: 14px;
  }

  .upload-subtext {
    font-size: 12px;
  }
}

/* Add Ad Button Styles */
.add-ad-btn {
  position: relative;
  width: 50%;
  min-width: 200px;
  max-width: 400px;
  padding: 16px 32px;
  margin-top: 32px;
  background: linear-gradient(135deg, #0074c7 0%, #005a9d 100%);
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 116, 199, 0.3);
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #005a9d 0%, #004080 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 116, 199, 0.4);
    
    &::before {
      left: 100%;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 3px 10px rgba(0, 116, 199, 0.3);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  &.loading {
    pointer-events: none;
  }
}

.btn-content,
.btn-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  z-index: 1;
}

.btn-icon {
  transition: transform 0.3s ease;
}

.add-ad-btn:hover:not(:disabled) .btn-icon {
  transform: scale(1.1) rotate(90deg);
}

.btn-text {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.loading-spinner {
  margin-right: 8px;
}

@media (max-width: 768px) {
  .add-ad-btn {
    width: 100%;
    max-width: 100%;
    padding: 14px 24px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .add-ad-btn {
    padding: 12px 20px;
    font-size: 15px;
    margin-top: 24px;
  }
}

/* Conditions Button Styles */
.conditions-btn {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  background: transparent;
  border: 2px solid #0074c7;
  border-radius: 8px;
  color: #0074c7;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 8px;
  text-decoration: none;

  &:hover {
    background: linear-gradient(135deg, #0074c7 0%, #005a9d 100%);
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 116, 199, 0.3);
    border-color: #005a9d;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 116, 199, 0.2);
  }

  .conditions-icon {
    margin-inline-end: 8px;
    transition: transform 0.3s ease;
  }

  &:hover .conditions-icon {
    transform: scale(1.1) rotate(5deg);
  }

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 8px;
  }
}

@media (max-width: 768px) {
  .conditions-btn {
    padding: 8px 12px;
    font-size: 14px;
  }
}
</style>
